"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ui_1 = require("@ocean-club/ui");
const Modal_container_1 = __importDefault(require("./Modal.container"));
const Modal = Modal_container_1.default;
Modal.Actions = ui_1.Modal.Actions;
Modal.Content = ui_1.Modal.Content;
Modal.Description = ui_1.Modal.Description;
Modal.Header = ui_1.Modal.Header;
exports.default = Modal;
//# sourceMappingURL=index.js.map